module.exports = __webpack_public_path__ + "assets/img/Apple iPhone 12 Black (1).e80d63cb.png";